import { Injectable, inject } from '@angular/core';
import { AssetService, MachineInfo, ModalService, PlantInfo } from '@schenck/rotec-components';
import { switchMap } from 'rxjs/operators';
import { MachineTaskInfo } from 'src/api';
import { TaskModalService } from 'src/components';
import { MachineTaskService } from 'src/services';
import { UpsertMachineTaskWizardComponent } from '../upsert-machine-task-wizard/upsert-machine-task-wizard.component';
import { Observable } from 'rxjs';

@Injectable()
export class MachineTaskModalService extends TaskModalService<MachineTaskInfo> {
  private readonly assetService = inject(AssetService);

  public machine$: Observable<MachineInfo> = this.task$.pipe(
    switchMap((task) => this.assetService.machine$(task.machineId))
  );
  public plant$: Observable<PlantInfo> = this.machine$.pipe(
    switchMap((machine) => this.assetService.plant$(machine.plantId))
  );

  constructor() {
    const taskService = inject(MachineTaskService);
    const modalService = inject(ModalService);

    super(taskService, modalService, UpsertMachineTaskWizardComponent);
  }
}
